import Vue from 'vue'
import Router from 'vue-router'
import homepageRoutes from './homepage';
import appRoutes from './app';
import dashboardRoutes from './dashboard';
import lpRoutes from './landingpages';

import $store from "@/store/store";
import updateTracking from "@/lib/track/update";

const routes = [].concat(homepageRoutes, appRoutes, dashboardRoutes, lpRoutes);
let asyncRoutes = [];
if (process.env.ADMIN_BUILD) {
  asyncRoutes.push(import('./admin'));
} else {
  routes.push({
    // Redirect from /admin to admin.brandly.com for staff users
    // or / for non-staff
    path: "/admin(/.*)?",
    async beforeEnter({path}) {
      // This won't work on initial navigation
      await $store.dispatch('waitForLogin');
      path = $store.getters.isStaff ? 'https://admin.brandly.com' + path : '/';
      window.location = path;
    }
  })
}

const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    // Always scroll to top
    return { x: 0, y: 0 }
  }
});

asyncRoutes.forEach(p => p.then(mod => router.addRoutes(mod.default)));

router.afterEach((to, from) => {
  // Work around Chrome "bugs" with sticky, and always scroll to top
  setTimeout(() => document.getElementById('app').scrollTop = 0, 1);
  // Tell tracking libs we've visited a new page
  // Vue calls afterEach before actually changing URL, so
  // use a delay to get the actual URL
  setTimeout(updateTracking, 20);
})

router.beforeEach((to, from, next) => {
  console.log('beforeEach', to.matched);
  // Find the title from the deepest child in the set of matched routes
  document.title = to.matched.map(r => r.meta.title).filter(Boolean).pop();
  // Enforce auth
  let authedRoute = to.matched.find(r => r.meta.requiresAuth);
  if (authedRoute) {
    $store.dispatch('waitForLogin').then(() => {
      const requiresIsStaff = !!to.matched.find(r => r.meta.requiresIsStaff);
      const isStaff = $store.getters.isStaff;
      if (requiresIsStaff && !isStaff) {
        // If a path requires "staff" permission and a user does not have it,
        // redirect the user to the dashboard.
        next({ path: '/dashboard' })
      } else {
        next();
      }
    }, err => {
      console.log('waitForLogin->',err);
      next(authedRoute.meta.requiresAuthRedirect || { path: '/signin', query: { redirect: to.fullPath }});
    });
  } else {
    next();
  }
});

router.onReady(() => {
  console.log('onReady');
  if (window.dataLayer) window.dataLayer.push({'event': 'optimize.activate'});
});

Vue.use(Router)

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js